import { useTranslation } from 'next-i18next';
import { CountdownComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyDateTimePicker from '../../../../common/VyDateTimePicker';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface CountdownSettingsTableInterface {
  component: CountdownComponentInterface;
  onChange: (c: CountdownComponentInterface) => void;
}

const CountdownSettingsTable = ({ component, onChange }: CountdownSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const pages = useSelector((state) => state.common.pages);

  const filteredPages = pages.filter((p) => p.visibility?.visibleWeb);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          label: t('pagebuilder:custom-time'),
          content: (
            <VyDateTimePicker
              isNullable
              date={component.customTime ? new Date(component.customTime) : undefined}
              onChange={(newDate) => onChange({ ...component, customTime: newDate })}
            />
          ),
        },
        {
          label: t('pagebuilder:countdown-postaction'),
          path: 'postaction',
          tooltip: t('pagebuilder:tooltip-countdown-postaction'),
          type: 'select',
          defaultValue: component.postaction,
          selectItems: [
            {
              name: t('pagebuilder:countdown-none'),
              value: 'none',
            },
            {
              name: t('pagebuilder:countdown-redirect'),
              value: 'redirect',
            },
          ],
        },
        {
          label: t('pagebuilder:event-page'),
          path: 'isInternalRoute',
          type: 'boolean',
          defaultValue: component.isInternalRoute,
          visible: component.postaction === 'redirect',
        },
        {
          label: t('pagebuilder:selected-page'),
          path: 'selectedPage',
          type: 'select',
          defaultValue: component.selectedPage,
          selectItems: filteredPages.map((p) => ({ name: p.name, value: p._id })),
          visible: component.postaction === 'redirect' && component.isInternalRoute,
        },
        {
          label: t('pagebuilder:redirect-to-url'),
          path: 'redirectLink',
          type: 'text',
          defaultValue: component.redirectLink,
          visible: component.postaction === 'redirect' && !component.isInternalRoute,
        },
      ],
    },
  ];
  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default CountdownSettingsTable;
